import React from 'react';
import { Link } from 'react-router-dom';
import './home_custom.css';

const HomeCustomSolutions = () => {
    return (
        <div className="home-custom-grid-item">
            <div className="home-custom-text-content">
                <h2 className="home-custom-h2">Need a <strong>custom</strong> solution?</h2>
                <h3 className="home-custom-h3">With expertise in both integrating systems and cloud solutions, we can provide hybrid solutions to fit your needs!</h3>
                <p className="home-custom-p">Curious about what can be achieved with AI?</p>
                <p className="home-custom-p">Any potential use case you would want to explore?</p>
                <p className="home-custom-p">Don't hesitate to contact us to discuss what we can do for you!</p>
                <Link to="/contact" className="link">You can reach us here</Link>
            </div>
        </div>
    );
};

export default HomeCustomSolutions;